const CHATBOT_TYPES = [
  {
    name: "INFORMATION RETRIEVAL DIGI WORKER",
    id: "INFORMATION_RETRIEVAL_CHATBOT",
  },
  {
    name: "INFORMATION COLLECTION DIGI WORKER",
    id: "INFORMATION_COLLECTION_CHATBOT",
  },
];

const MODEL_FILE_UPLOAD_ERROR = "No files were uploaded, please try again.";

const USAGE_TIMESTAMPS = [
  { name: "Last Hour", id: "LAST_HOUR" },
  { name: "Last 24 Hours", id: "LAST_DAY" },
  { name: "Last Week", id: "LAST_WEEK" },
  { name: "Last Month", id: "LAST_MONTH" },
  { name: "Last Year", id: "LAST_YEAR" },
];

const BILLING_CYCLES = [
  { name: "Monthly (PAYG)", id: "MONTHLY_PAYG" },
  { name: "Annually", id: "ANNUALLY" },
];

const USAGE_MODULES = {
  EXTRACTION_MODEL: "Extraction Model",
  SMART_CLASSES: "Smart Classes",
  DOCUMENT_EXTRACTOR: "Document Extractor",
  WORKBENCH: "Workbench",
  INTELLI_DOCS: "Intelli Docs",
};

const USAGE_METHODS = {
  GET: "Get",
  HEAD: "Head",
  POST: "Post",
  PUT: "Put",
  PATCH: "Patch",
  DELETE: "Delete",
  OPTIONS: "Options",
  TRACE: "Trace",
};

const ROLE_LABELS = {
  SYSTEM_ADMIN: "System Admin",
  PARTNER: "Partner",
  ADMINISTRATOR: "Administrator",
  PRODUCT_MANAGER: "Product Manager",
  DESIGNER: "Designer",
  END_USER: "End User",
};

const WORKQUEUE_STATUS_OBJECT = [
  { id: "ACTIVE", name: "Active" },
  { id: "PASSIVE", name: "Passive" },
];

const SMART_BUILDER_STATE_OPTIONS = [
  { id: "INITIALIZED", value: "Initialized" },
  { id: "TRAINING_DONE", value: "Training Done" },
  { id: "DEPLOYED_AND_RUNNING", value: "Deployed and running" },
  { id: "STOPPED", value: "Stopped" },
  { id: "APPROVED", value: "Approved" },
];
const SMART_CLASS_STATE_OPTIONS = [
  { id: "INITIALIZED", value: "Initialized" },
  { id: "TRAINING_DONE", value: "Training Done" },
  { id: "DEPLOYED_AND_RUNNING", value: "Deployed and running" },
  { id: "STOPPED", value: "Stopped" },
];

const COUNTRIES_OPTIONS = [
  {
    countryLabel: "Afghanistan",
    countryValue: "AFGHANISTAN",
    currency: "USD ($)",
  },
  { countryLabel: "Albania", countryValue: "ALBANIA", currency: "USD ($)" },
  { countryLabel: "Algeria", countryValue: "ALGERIA", currency: "USD ($)" },
  { countryLabel: "Andorra", countryValue: "ANDORRA", currency: "EUR (€)" },
  { countryLabel: "Angola", countryValue: "ANGOLA", currency: "USD ($)" },
  {
    countryLabel: "Antigua and Barbuda",
    countryValue: "ANTIGUA_AND_BARBUDA",
    currency: "USD ($)",
  },
  { countryLabel: "Argentina", countryValue: "ARGENTINA", currency: "USD ($)" },
  { countryLabel: "Armenia", countryValue: "ARMENIA", currency: "USD ($)" },
  { countryLabel: "Australia", countryValue: "AUSTRALIA", currency: "USD ($)" },
  { countryLabel: "Austria", countryValue: "AUSTRIA", currency: "EUR (€)" },
  {
    countryLabel: "Azerbaijan",
    countryValue: "AZERBAIJAN",
    currency: "USD ($)",
  },
  { countryLabel: "Bahamas", countryValue: "BAHAMAS", currency: "USD ($)" },
  { countryLabel: "Bahrain", countryValue: "BAHRAIN", currency: "USD ($)" },
  {
    countryLabel: "Bangladesh",
    countryValue: "BANGLADESH",
    currency: "USD ($)",
  },
  { countryLabel: "Barbados", countryValue: "BARBADOS", currency: "USD ($)" },
  { countryLabel: "Belarus", countryValue: "BELARUS", currency: "USD ($)" },
  { countryLabel: "Belgium", countryValue: "BELGIUM", currency: "EUR (€)" },
  { countryLabel: "Belize", countryValue: "BELIZE", currency: "USD ($)" },
  { countryLabel: "Benin", countryValue: "BENIN", currency: "USD ($)" },
  { countryLabel: "Bhutan", countryValue: "BHUTAN", currency: "USD ($)" },
  { countryLabel: "Bolivia", countryValue: "BOLIVIA", currency: "USD ($)" },
  {
    countryLabel: "Bosnia and Herzegovina",
    countryValue: "BOSNIA_AND_HERZEGOVINA",
    currency: "USD ($)",
  },
  { countryLabel: "Botswana", countryValue: "BOTSWANA", currency: "USD ($)" },
  { countryLabel: "Brazil", countryValue: "BRAZIL", currency: "USD ($)" },
  { countryLabel: "Brunei", countryValue: "BRUNEI", currency: "USD ($)" },
  { countryLabel: "Bulgaria", countryValue: "BULGARIA", currency: "USD ($)" },
  {
    countryLabel: "Burkina Faso",
    countryValue: "BURKINA_FASO",
    currency: "USD ($)",
  },
  { countryLabel: "Burundi", countryValue: "BURUNDI", currency: "USD ($)" },
  {
    countryLabel: "Cabo Verde",
    countryValue: "CABO_VERDE",
    currency: "USD ($)",
  },
  { countryLabel: "Cambodia", countryValue: "CAMBODIA", currency: "USD ($)" },
  { countryLabel: "Cameroon", countryValue: "CAMEROON", currency: "USD ($)" },
  { countryLabel: "Canada", countryValue: "CANADA", currency: "USD ($)" },
  {
    countryLabel: "Central African Republic",
    countryValue: "CENTRAL_AFRICAN_REPUBLIC",
    currency: "USD ($)",
  },
  { countryLabel: "Chad", countryValue: "CHAD", currency: "USD ($)" },
  { countryLabel: "Chile", countryValue: "CHILE", currency: "USD ($)" },
  { countryLabel: "China", countryValue: "CHINA", currency: "USD ($)" },
  { countryLabel: "Colombia", countryValue: "COLOMBIA", currency: "USD ($)" },
  { countryLabel: "Comoros", countryValue: "COMOROS", currency: "USD ($)" },
  {
    countryLabel: "Congo (Brazzaville)",
    countryValue: "CONGO_BRAZZAVILLE",
    currency: "USD ($)",
  },
  {
    countryLabel: "Congo (Kinshasa)",
    countryValue: "CONGO_KINSHASA",
    currency: "USD ($)",
  },
  {
    countryLabel: "Costa Rica",
    countryValue: "COSTA_RICA",
    currency: "USD ($)",
  },
  {
    countryLabel: "Côte d'Ivoire",
    countryValue: "COTE_DIVOIRE",
    currency: "USD ($)",
  },
  { countryLabel: "Croatia", countryValue: "CROATIA", currency: "USD ($)" },
  { countryLabel: "Cuba", countryValue: "CUBA", currency: "USD ($)" },
  { countryLabel: "Cyprus", countryValue: "CYPRUS", currency: "EUR (€)" },
  { countryLabel: "Czechia", countryValue: "CZECHIA", currency: "USD ($)" },
  { countryLabel: "Denmark", countryValue: "DENMARK", currency: "USD ($)" },
  { countryLabel: "Djibouti", countryValue: "DJIBOUTI", currency: "USD ($)" },
  { countryLabel: "Dominica", countryValue: "DOMINICA", currency: "USD ($)" },
  {
    countryLabel: "Dominican Republic",
    countryValue: "DOMINICAN_REPUBLIC",
    currency: "USD ($)",
  },
  { countryLabel: "Ecuador", countryValue: "ECUADOR", currency: "USD ($)" },
  { countryLabel: "Egypt", countryValue: "EGYPT", currency: "USD ($)" },
  {
    countryLabel: "El Salvador",
    countryValue: "EL_SALVADOR",
    currency: "USD ($)",
  },
  {
    countryLabel: "Equatorial Guinea",
    countryValue: "EQUATORIAL_GUINEA",
    currency: "USD ($)",
  },
  { countryLabel: "Eritrea", countryValue: "ERITREA", currency: "USD ($)" },
  { countryLabel: "Estonia", countryValue: "ESTONIA", currency: "EUR (€)" },
  { countryLabel: "Eswatini", countryValue: "ESWATINI", currency: "USD ($)" },
  { countryLabel: "Ethiopia", countryValue: "ETHIOPIA", currency: "USD ($)" },
  { countryLabel: "Fiji", countryValue: "FIJI", currency: "USD ($)" },
  { countryLabel: "Finland", countryValue: "FINLAND", currency: "EUR (€)" },
  { countryLabel: "France", countryValue: "FRANCE", currency: "EUR (€)" },
  { countryLabel: "Gabon", countryValue: "GABON", currency: "USD ($)" },
  { countryLabel: "Gambia", countryValue: "GAMBIA", currency: "USD ($)" },
  { countryLabel: "Georgia", countryValue: "GEORGIA", currency: "USD ($)" },
  { countryLabel: "Germany", countryValue: "GERMANY", currency: "EUR (€)" },
  { countryLabel: "Ghana", countryValue: "GHANA", currency: "USD ($)" },
  { countryLabel: "Greece", countryValue: "GREECE", currency: "EUR (€)" },
  { countryLabel: "Grenada", countryValue: "GRENADA", currency: "USD ($)" },
  { countryLabel: "Guatemala", countryValue: "GUATEMALA", currency: "USD ($)" },
  { countryLabel: "Guinea", countryValue: "GUINEA", currency: "USD ($)" },
  {
    countryLabel: "Guinea-Bissau",
    countryValue: "GUINEA_BISSAU",
    currency: "USD ($)",
  },
  { countryLabel: "Guyana", countryValue: "GUYANA", currency: "USD ($)" },
  { countryLabel: "Haiti", countryValue: "HAITI", currency: "USD ($)" },
  { countryLabel: "Honduras", countryValue: "HONDURAS", currency: "USD ($)" },
  { countryLabel: "Hungary", countryValue: "HUNGARY", currency: "USD ($)" },
  { countryLabel: "Iceland", countryValue: "ICELAND", currency: "USD ($)" },
  { countryLabel: "India", countryValue: "INDIA", currency: "USD ($)" },
  { countryLabel: "Indonesia", countryValue: "INDONESIA", currency: "USD ($)" },
  { countryLabel: "Iran", countryValue: "IRAN", currency: "USD ($)" },
  { countryLabel: "Iraq", countryValue: "IRAQ", currency: "USD ($)" },
  { countryLabel: "Ireland", countryValue: "IRELAND", currency: "EUR (€)" },
  { countryLabel: "Israel", countryValue: "ISRAEL", currency: "USD ($)" },
  { countryLabel: "Italy", countryValue: "ITALY", currency: "EUR (€)" },
  { countryLabel: "Jamaica", countryValue: "JAMAICA", currency: "USD ($)" },
  { countryLabel: "Japan", countryValue: "JAPAN", currency: "USD ($)" },
  { countryLabel: "Jordan", countryValue: "JORDAN", currency: "USD ($)" },
  {
    countryLabel: "Kazakhstan",
    countryValue: "KAZAKHSTAN",
    currency: "USD ($)",
  },
  { countryLabel: "Kenya", countryValue: "KENYA", currency: "USD ($)" },
  { countryLabel: "Kiribati", countryValue: "KIRIBATI", currency: "USD ($)" },
  {
    countryLabel: "Korea (North)",
    countryValue: "NORTH_KOREA",
    currency: "USD ($)",
  },
  {
    countryLabel: "Korea (South)",
    countryValue: "SOUTH_KOREA",
    currency: "USD ($)",
  },
  { countryLabel: "Kuwait", countryValue: "KUWAIT", currency: "USD ($)" },
  {
    countryLabel: "Kyrgyzstan",
    countryValue: "KYRGYZSTAN",
    currency: "USD ($)",
  },
  { countryLabel: "Laos", countryValue: "LAOS", currency: "USD ($)" },
  { countryLabel: "Latvia", countryValue: "LATVIA", currency: "EUR (€)" },
  { countryLabel: "Lebanon", countryValue: "LEBANON", currency: "USD ($)" },
  { countryLabel: "Lesotho", countryValue: "LESOTHO", currency: "USD ($)" },
  { countryLabel: "Liberia", countryValue: "LIBERIA", currency: "USD ($)" },
  { countryLabel: "Libya", countryValue: "LIBYA", currency: "USD ($)" },
  {
    countryLabel: "Liechtenstein",
    countryValue: "LIECHTENSTEIN",
    currency: "USD ($)",
  },
  { countryLabel: "Lithuania", countryValue: "LITHUANIA", currency: "EUR (€)" },
  {
    countryLabel: "Luxembourg",
    countryValue: "LUXEMBOURG",
    currency: "EUR (€)",
  },
  {
    countryLabel: "Madagascar",
    countryValue: "MADAGASCAR",
    currency: "USD ($)",
  },
  { countryLabel: "Malawi", countryValue: "MALAWI", currency: "USD ($)" },
  { countryLabel: "Malaysia", countryValue: "MALAYSIA", currency: "USD ($)" },
  { countryLabel: "Maldives", countryValue: "MALDIVES", currency: "USD ($)" },
  { countryLabel: "Mali", countryValue: "MALI", currency: "USD ($)" },
  { countryLabel: "Malta", countryValue: "MALTA", currency: "EUR (€)" },
  {
    countryLabel: "Marshall Islands",
    countryValue: "MARSHALL_ISLANDS",
    currency: "USD ($)",
  },
  {
    countryLabel: "Mauritania",
    countryValue: "MAURITANIA",
    currency: "USD ($)",
  },
  { countryLabel: "Mauritius", countryValue: "MAURITIUS", currency: "USD ($)" },
  { countryLabel: "Mexico", countryValue: "MEXICO", currency: "USD ($)" },
  {
    countryLabel: "Micronesia (Federated States of)",
    countryValue: "MICRONESIA",
    currency: "USD ($)",
  },
  { countryLabel: "Moldova", countryValue: "MOLDOVA", currency: "USD ($)" },
  { countryLabel: "Monaco", countryValue: "MONACO", currency: "EUR (€)" },
  { countryLabel: "Mongolia", countryValue: "MONGOLIA", currency: "USD ($)" },
  {
    countryLabel: "Montenegro",
    countryValue: "MONTENEGRO",
    currency: "EUR (€)",
  },
  { countryLabel: "Morocco", countryValue: "MOROCCO", currency: "USD ($)" },
  {
    countryLabel: "Mozambique",
    countryValue: "MOZAMBIQUE",
    currency: "USD ($)",
  },
  { countryLabel: "Myanmar", countryValue: "MYANMAR", currency: "USD ($)" },
  { countryLabel: "Namibia", countryValue: "NAMIBIA", currency: "USD ($)" },
  { countryLabel: "Nauru", countryValue: "NAURU", currency: "USD ($)" },
  { countryLabel: "Nepal", countryValue: "NEPAL", currency: "USD ($)" },
  {
    countryLabel: "Netherlands",
    countryValue: "NETHERLANDS",
    currency: "EUR (€)",
  },
  {
    countryLabel: "New Zealand",
    countryValue: "NEW_ZEALAND",
    currency: "USD ($)",
  },
  { countryLabel: "Nicaragua", countryValue: "NICARAGUA", currency: "USD ($)" },
  { countryLabel: "Niger", countryValue: "NIGER", currency: "USD ($)" },
  { countryLabel: "Nigeria", countryValue: "NIGERIA", currency: "USD ($)" },
  {
    countryLabel: "North Macedonia",
    countryValue: "NORTH_MACEDONIA",
    currency: "USD ($)",
  },
  { countryLabel: "Norway", countryValue: "NORWAY", currency: "USD ($)" },
  { countryLabel: "Oman", countryValue: "OMAN", currency: "USD ($)" },
  { countryLabel: "Pakistan", countryValue: "PAKISTAN", currency: "USD ($)" },
  { countryLabel: "Palau", countryValue: "PALAU", currency: "USD ($)" },
  { countryLabel: "Panama", countryValue: "PANAMA", currency: "USD ($)" },
  {
    countryLabel: "Papua New Guinea",
    countryValue: "PAPUA_NEW_GUINEA",
    currency: "USD ($)",
  },
  { countryLabel: "Paraguay", countryValue: "PARAGUAY", currency: "USD ($)" },
  { countryLabel: "Peru", countryValue: "PERU", currency: "USD ($)" },
  {
    countryLabel: "Philippines",
    countryValue: "PHILIPPINES",
    currency: "USD ($)",
  },
  { countryLabel: "Poland", countryValue: "POLAND", currency: "USD ($)" },
  { countryLabel: "Portugal", countryValue: "PORTUGAL", currency: "EUR (€)" },
  { countryLabel: "Qatar", countryValue: "QATAR", currency: "USD ($)" },
  { countryLabel: "Romania", countryValue: "ROMANIA", currency: "USD ($)" },
  { countryLabel: "Russia", countryValue: "RUSSIA", currency: "USD ($)" },
  { countryLabel: "Rwanda", countryValue: "RWANDA", currency: "USD ($)" },
  {
    countryLabel: "Saint Kitts and Nevis",
    countryValue: "SAINT_KITTS_AND_NEVIS",
    currency: "USD ($)",
  },
  {
    countryLabel: "Saint Lucia",
    countryValue: "SAINT_LUCIA",
    currency: "USD ($)",
  },
  {
    countryLabel: "Saint Vincent and the Grenadines",
    countryValue: "SAINT_VINCENT_AND_THE_GRENADINES",
    currency: "USD ($)",
  },
  { countryLabel: "Samoa", countryValue: "SAMOA", currency: "USD ($)" },
  {
    countryLabel: "San Marino",
    countryValue: "SAN_MARINO",
    currency: "EUR (€)",
  },
  {
    countryLabel: "Sao Tome and Principe",
    countryValue: "SAO_TOME_AND_PRINCIPE",
    currency: "USD ($)",
  },
  {
    countryLabel: "Saudi Arabia",
    countryValue: "SAUDI_ARABIA",
    currency: "USD ($)",
  },
  { countryLabel: "Senegal", countryValue: "SENEGAL", currency: "USD ($)" },
  { countryLabel: "Serbia", countryValue: "SERBIA", currency: "USD ($)" },
  {
    countryLabel: "Seychelles",
    countryValue: "SEYCHELLES",
    currency: "USD ($)",
  },
  {
    countryLabel: "Sierra Leone",
    countryValue: "SIERRA_LEONE",
    currency: "USD ($)",
  },
  { countryLabel: "Singapore", countryValue: "SINGAPORE", currency: "USD ($)" },
  { countryLabel: "Slovakia", countryValue: "SLOVAKIA", currency: "EUR (€)" },
  { countryLabel: "Slovenia", countryValue: "SLOVENIA", currency: "EUR (€)" },
  {
    countryLabel: "Solomon Islands",
    countryValue: "SOLOMON_ISLANDS",
    currency: "USD ($)",
  },
  { countryLabel: "Somalia", countryValue: "SOMALIA", currency: "USD ($)" },
  {
    countryLabel: "South Africa",
    countryValue: "SOUTH_AFRICA",
    currency: "ZAR (R)",
  },
  {
    countryLabel: "South Sudan",
    countryValue: "SOUTH_SUDAN",
    currency: "USD ($)",
  },
  { countryLabel: "Spain", countryValue: "SPAIN", currency: "EUR (€)" },
  { countryLabel: "Sri Lanka", countryValue: "SRI_LANKA", currency: "USD ($)" },
  { countryLabel: "Sudan", countryValue: "SUDAN", currency: "USD ($)" },
  { countryLabel: "Suriname", countryValue: "SURINAME", currency: "USD ($)" },
  { countryLabel: "Sweden", countryValue: "SWEDEN", currency: "USD ($)" },
  {
    countryLabel: "Switzerland",
    countryValue: "SWITZERLAND",
    currency: "USD ($)",
  },
  { countryLabel: "Syria", countryValue: "SYRIA", currency: "USD ($)" },
  {
    countryLabel: "Tajikistan",
    countryValue: "TAJIKISTAN",
    currency: "USD ($)",
  },
  { countryLabel: "Tanzania", countryValue: "TANZANIA", currency: "USD ($)" },
  { countryLabel: "Thailand", countryValue: "THAILAND", currency: "USD ($)" },
  { countryLabel: "Togo", countryValue: "TOGO", currency: "USD ($)" },
  { countryLabel: "Tonga", countryValue: "TONGA", currency: "USD ($)" },
  {
    countryLabel: "Trinidad and Tobago",
    countryValue: "TRINIDAD_AND_TOBAGO",
    currency: "USD ($)",
  },
  { countryLabel: "Tunisia", countryValue: "TUNISIA", currency: "USD ($)" },
  { countryLabel: "Turkey", countryValue: "TURKEY", currency: "USD ($)" },
  {
    countryLabel: "Turkmenistan",
    countryValue: "TURKMENISTAN",
    currency: "USD ($)",
  },
  { countryLabel: "Tuvalu", countryValue: "TUVALU", currency: "USD ($)" },
  { countryLabel: "Uganda", countryValue: "UGANDA", currency: "USD ($)" },
  { countryLabel: "Ukraine", countryValue: "UKRAINE", currency: "USD ($)" },
  {
    countryLabel: "United Arab Emirates",
    countryValue: "UNITED_ARAB_EMIRATES",
    currency: "USD ($)",
  },
  {
    countryLabel: "United Kingdom",
    countryValue: "UNITED_KINGDOM",
    currency: "GBP (£)",
    vatRate: 20.0,
  },
  {
    countryLabel: "United States",
    countryValue: "UNITED_STATES",
    currency: "USD ($)",
  },
  { countryLabel: "Uruguay", countryValue: "URUGUAY", currency: "USD ($)" },
  {
    countryLabel: "Uzbekistan",
    countryValue: "UZBEKISTAN",
    currency: "USD ($)",
  },
  { countryLabel: "Vanuatu", countryValue: "VANUATU", currency: "USD ($)" },
  { countryLabel: "Venezuela", countryValue: "VENEZUELA", currency: "USD ($)" },
  { countryLabel: "Vietnam", countryValue: "VIETNAM", currency: "USD ($)" },
  { countryLabel: "Yemen", countryValue: "YEMEN", currency: "USD ($)" },
  { countryLabel: "Zambia", countryValue: "ZAMBIA", currency: "USD ($)" },
  { countryLabel: "Zimbabwe", countryValue: "ZIMBABWE", currency: "USD ($)" },
  { countryLabel: "Palestine", countryValue: "PALESTINE", currency: "USD ($)" },
  {
    countryLabel: "Vatican City",
    countryValue: "VATICAN_CITY",
    currency: "EUR (€)",
  },
];

const CURRENCY_MAP = {
  USD: "$",
  GBP: "£",
  EUR: "€",
  ZAR: "R",
};

const FIELD_TYPE_OPTIONS = [
  { id: "INTEGER", value: "Integer" },
  { id: "FLOAT", value: "Float" },
  { id: "STRING", value: "String" },
  { id: "BOOLEAN", value: "Boolean" },
  { id: "TABLE", value: "Table" },
];

const BOOLEAN_OPTIONS = [
  { id: "TRUE", value: "True" },
  { id: "FALSE", value: "False" },
];

const INTELIEDOCS_SEARCH_OPTIONS = [
  { id: "name", value: "Name" },
  { id: "type", value: "Type" },
];

const INTELIEDOCS_TYPE_OPTIONS = [
  { id: "Smart Extract Mapper", value: "Smart Extract Mapper" },
  { id: "Smart Class", value: "Smart Class" },
  { id: "Smart Queue", value: "Smart Queue" },
];

const COLORS = [
  "#1a237e",
  "#ff9800",
  "#b71c1c",
  "#f44336",
  "#ff5722",
  "#e91e63",
  "#cddc39",
  "#33691e",
  "#9c27b0",
  "#9e9e9e",
  "#bf360c",
  "#673ab7",
  "#ffc107",
  "#f57f17",
  "#3f51b5",
  "#1b5e20",
  "#8bc34a",
  "#2196f3",
  "#006064",
  "#311b92",
  "#ffeb3b",
  "#03a9f4",
  "#00bcd4",
  "#009688",
  "#4caf50",
  "#795548",
  "#607d8b",
  "#0d47a1",
  "#880e4f",
  "#3e2723",
  "#e65100",
  "#4a148c",
  "#ff6f00",
  "#827717",
  "#004d40",
  "#01579b",
  "#aeea00",
  "#0091ea",
  "#00bfa5",
  "#ffd600",
  "#dd2c00",
  "#ff6d00",
  "#304ffe",
  "#c51162",
  "#00b8d4",
];
const INTELIEDOCS_SIMILAR_DOCUMENTS_OPTIONS = [
  { id: "SMART_EXTRACT", value: "Smart Extract" },
  { id: "SMART_CLASSES", value: "Smart Class" },
  { id: "SMART_QUEUE", value: "Smart Queue" },
];

const PAYMENT_STATUS_OPTIONS = [
  { id: "PENDING", name: "Pending" },
  { id: "BILL_GENERATED", name: "Bill Generated" },
  { id: "PAYMENT_SUCCESS", name: "Payment Success" },
  { id: "PAYMENT_FAILED", name: "Payment Failed" },
];

const MONTH_OPTIONS = [
  { id: 1, name: "January" },
  { id: 2, name: "February" },
  { id: 3, name: "March" },
  { id: 4, name: "April" },
  { id: 5, name: "May" },
  { id: 6, name: "June" },
  { id: 7, name: "July" },
  { id: 8, name: "August" },
  { id: 9, name: "September" },
  { id: 10, name: "October" },
  { id: 11, name: "November" },
  { id: 12, name: "December" },
];

const GOOGLE_FONT_OPTIONS = [
  { id: "LucidaGrande, sans-serif", name: "Lucida Grande" },
  { id: "Arial, sans-serif", name: "Arial" },
  { id: "Verdana, sans-serif", name: "Verdana" },
  { id: "Helvetica, sans-serif", name: "Helvetica" },
  { id: "Tahoma, sans-serif", name: "Tahoma" },
  { id: "'Trebuchet MS', sans-serif", name: "Trebuchet MS" },
  { id: "'Times New Roman', serif", name: "Times New Roman" },
  { id: "Georgia, serif", name: "Georgia" },
  { id: "Garamond, serif", name: "Garamond" },
  { id: "'Courier New', monospace", name: "Courier New" },
  { id: "'Brush Script MT', cursive", name: "Brush Script MT" },
  { id: "'Palatino Linotype', serif", name: "Palatino Linotype" },
  { id: "'Lucida Sans Unicode', sans-serif", name: "Lucida Sans Unicode" },
  { id: "'Lucida Console', monospace", name: "Lucida Console" },
  { id: "Impact, sans-serif", name: "Impact" },
  { id: "'Comic Sans MS', cursive", name: "Comic Sans MS" },
  { id: "system-ui, sans-serif", name: "System UI" },
];

const MONTHLY_COST_TIERS = [
  { id: 1, min: 420, max: 420, rate: 0.12, models: 1 },
  { id: 2, min: 421, max: 833, rate: 0.1176, models: 1 },
  { id: 3, min: 834, max: 2083, rate: 0.1117, models: 2 },
  { id: 4, min: 2084, max: 4167, rate: 0.0994, models: 3 },
  { id: 5, min: 4168, max: 8333, rate: 0.0886, models: 4 },
  { id: 6, min: 8334, max: 16667, rate: 0.0816, models: 5 },
  { id: 7, min: 16668, max: 25000, rate: 0.0768, models: 10 },
  { id: 8, min: 25001, max: 33333, rate: 0.072, models: 10 },
  { id: 9, min: 33334, max: 41667, rate: 0.0672, models: 10 },
  { id: 10, min: 41668, max: 50000, rate: 0.0648, models: 10 },
  { id: 11, min: 50001, max: 58333, rate: 0.0636, models: 10 },
  { id: 12, min: 58334, max: 66667, rate: 0.0624, models: 10 },
  { id: 13, min: 66668, max: 75000, rate: 0.0612, models: 10 },
  { id: 14, min: 75001, max: 83333, rate: 0.06, models: 10 },
  { id: 15, min: 83334, max: 166667, rate: 0.0552, models: 10 },
  { id: 16, min: 166668, max: 250000, rate: 0.0504, models: 10 },
];

const ANNUAL_COST_TIERS = [
  { id: 1, min: 5000, max: 5000, rate: 0.1, models: 1 },
  { id: 2, min: 5001, max: 10000, rate: 0.098, models: 1 },
  { id: 3, min: 10001, max: 25000, rate: 0.0931, models: 2 },
  { id: 4, min: 25001, max: 50000, rate: 0.0828, models: 3 },
  { id: 5, min: 50001, max: 100000, rate: 0.0738, models: 4 },
  { id: 6, min: 100001, max: 200000, rate: 0.068, models: 5 },
  { id: 7, min: 200001, max: 300000, rate: 0.064, models: 10 },
  { id: 8, min: 300001, max: 400000, rate: 0.06, models: 10 },
  { id: 9, min: 400001, max: 500000, rate: 0.056, models: 10 },
  { id: 10, min: 500001, max: 600000, rate: 0.054, models: 10 },
  { id: 11, min: 600001, max: 700000, rate: 0.053, models: 10 },
  { id: 12, min: 700001, max: 800000, rate: 0.052, models: 10 },
  { id: 13, min: 800001, max: 900000, rate: 0.051, models: 10 },
  { id: 14, min: 900001, max: 1000000, rate: 0.05, models: 10 },
  { id: 15, min: 1000001, max: 2000000, rate: 0.046, models: 10 },
  { id: 16, min: 2000001, max: 3000000, rate: 0.042, models: 10 },
];

const CONNECTOR_STATUS = [
  { id: "ACTIVE", name: "Active" },
  { id: "INITIALIZED", name: "Initialized" },
  { id: "FAILED", name: "Failed" },
  { id: "VERIFICATION_PENDING", name: "Verification Pending" },
];

const ENGAGEMENT_STATUS = {
  CONNECTED: "Connected",
  AVAILABLE: "Available",
};

const CONNECTOR_TYPE = [
  { id: "EMAIL", name: "Email" },
  // { id: "GOOGLE_DRIVE", name: "Cloud Storage" },
  { id: "SECURE_FILE_TRANSFER", name: "Secure File Transfer Protocol" },
];

const CLOUD_PROVIDER = [
  { id: "Google_Drive", name: "Google Drive" },
  // {id: "Dropbox ", name: "Dropbox "}
];

const FILE_TYPE = [
  { id: "docx", name: "Docx" },
  { id: "pdf", name: "Pdf" },
  { id: "image", name: "Image" },
  { id: "text", name: "Text" },
];

const EXPORT_FILE_TYPE = [
  { id: "ALL", name: "All" },
  { id: "EXCEL", name: "EXCEL" },
  { id: "CSV", name: "CSV" },
  { id: "JSON", name: "JSON" },
  { id: "TEMPLATE", name: "TEMPLATE" },
];

const OVERWRITE_POLICY_OPTIONS = [
  { id: "OVERWRITE ", name: "Overwrite" },
  { id: "APPEND", name: "Append" },
  { id: "FAIL_IF_EXISTS ", name: "Fail if exists" },
];

const IDLE_LOGOUT_TIME = 30 * 60 * 1000; //30 minutes

const AUTH_TYPE = [
  { id: "APP_PASSWORD", name: "App Password" },
  { id: "GRAPH_API", name: "Graph API" },
];

const SCHEDULE_TYPE = [
  { id: "FIXED_RATE_BASED", name: "Standard Scheduler" },
  { id: "CRON_BASED", name: "Custom Scheduler" },
  // {id: "MANUAL", name: "Manual"},
];

const CRON_EXPRESSION = [
  { id: "300000", name: "5 minutes" },
  { id: "600000", name: "10 minutes" },
  { id: "900000", name: "15 minutes" },
  { id: "1800000", name: "30 minutes" },
  { id: "3600000", name: "1 hour" },
  { id: "21600000", name: "6 hours" },
  { id: "43200000", name: "12 hours" },
  { id: "86400000", name: "24 hours" },
];

const SCHEDULE_TIME = [
  { id: "0:0", name: "00:00" },
  { id: "0:30", name: "00:30" },
  { id: "1:0", name: "01:00" },
  { id: "1:30", name: "01:30" },
  { id: "2:0", name: "02:00" },
  { id: "2:30", name: "02:30" },
  { id: "3:0", name: "03:00" },
  { id: "3:30", name: "03:30" },
  { id: "4:0", name: "04:00" },
  { id: "4:30", name: "04:30" },
  { id: "5:0", name: "05:00" },
  { id: "5:30", name: "05:30" },
  { id: "6:0", name: "06:00" },
  { id: "6:30", name: "06:30" },
  { id: "7:0", name: "07:00" },
  { id: "7:30", name: "07:30" },
  { id: "8:0", name: "08:00" },
  { id: "8:30", name: "08:30" },
  { id: "9:0", name: "09:00" },
  { id: "9:30", name: "09:30" },
  { id: "10:0", name: "10:00" },
  { id: "10:30", name: "10:30" },
  { id: "11:0", name: "11:00" },
  { id: "11:30", name: "11:30" },
  { id: "12:0", name: "12:00" },
  { id: "12:30", name: "12:30" },
  { id: "13:0", name: "13:00" },
  { id: "13:30", name: "13:30" },
  { id: "14:0", name: "14:00" },
  { id: "14:30", name: "14:30" },
  { id: "15:0", name: "15:00" },
  { id: "15:30", name: "15:30" },
  { id: "16:0", name: "16:00" },
  { id: "16:30", name: "16:30" },
  { id: "17:0", name: "17:00" },
  { id: "17:30", name: "17:30" },
  { id: "18:0", name: "18:00" },
  { id: "18:30", name: "18:30" },
  { id: "19:0", name: "19:00" },
  { id: "19:30", name: "19:30" },
  { id: "20:0", name: "20:00" },
  { id: "20:30", name: "20:30" },
  { id: "21:0", name: "21:00" },
  { id: "21:30", name: "21:30" },
  { id: "22:0", name: "22:00" },
  { id: "22:30", name: "22:30" },
  { id: "23:0", name: "23:00" },
  { id: "23:30", name: "23:30" },
];

const DAYS_OF_WEEK = [
  { id: "MON", name: "Monday" },
  { id: "TUE", name: "Tuesday" },
  { id: "WED", name: "Wednesday" },
  { id: "THU", name: "Thursday" },
  { id: "FRI", name: "Friday" },
  { id: "SAT", name: "Saturday" },
  { id: "SUN", name: "Sunday" },
];

const CUSTOM_SCHEDULER_FREQUENCY = [
  { id: "DAILY", name: "Daily" },
  { id: "EVERY_WEEKDAY", name: "Every Weekday" },
  { id: "WEEKLY", name: "Custom Days" },
];

const IMPORT_STATIC_KEYS = [
  "config.appPasswordAuthDetails.emailHost",
  "config.remoteDirectory",
  "config.username",
  "config.port",
  "config.host",
  "config.graphApiAuthDetails.tenantId",
  "config.graphApiAuthDetails.clientId",
  "config.graphApiAuthDetails.clientSecret",
  "config.appPasswordAuthDetails.password",
];
const EXPORT_STATIC_KEYS = [
  "exportConnectorConfig.username",
  "exportConnectorConfig.host",
  "exportConnectorConfig.port",
  "exportConnectorConfig.remoteDirectory",
];

const ALLOWED_CURRENCIES = ["USD", "GBP", "EUR", "ZAR"];

const CURRENCY_DISPLAY_MAP = {
  USD: "USD ($)",
  GBP: "GBP (£)",
  EUR: "EUR (€)",
  ZAR: "ZAR (R)",
};

export {
  CHATBOT_TYPES,
  MODEL_FILE_UPLOAD_ERROR,
  USAGE_TIMESTAMPS,
  USAGE_MODULES,
  USAGE_METHODS,
  ROLE_LABELS,
  WORKQUEUE_STATUS_OBJECT,
  BOOLEAN_OPTIONS,
  FIELD_TYPE_OPTIONS,
  INTELIEDOCS_SEARCH_OPTIONS,
  INTELIEDOCS_TYPE_OPTIONS,
  COLORS,
  INTELIEDOCS_SIMILAR_DOCUMENTS_OPTIONS,
  PAYMENT_STATUS_OPTIONS,
  GOOGLE_FONT_OPTIONS,
  MONTH_OPTIONS,
  IDLE_LOGOUT_TIME,
  SMART_CLASS_STATE_OPTIONS,
  SMART_BUILDER_STATE_OPTIONS,
  MONTHLY_COST_TIERS,
  ANNUAL_COST_TIERS,
  BILLING_CYCLES,
  COUNTRIES_OPTIONS,
  CURRENCY_MAP,
  CONNECTOR_STATUS,
  SCHEDULE_TYPE,
  CRON_EXPRESSION,
  CONNECTOR_TYPE,
  ENGAGEMENT_STATUS,
  AUTH_TYPE,
  CLOUD_PROVIDER,
  OVERWRITE_POLICY_OPTIONS,
  FILE_TYPE,
  EXPORT_FILE_TYPE,
  SCHEDULE_TIME,
  DAYS_OF_WEEK,
  CUSTOM_SCHEDULER_FREQUENCY,
  IMPORT_STATIC_KEYS,
  EXPORT_STATIC_KEYS,
  CURRENCY_DISPLAY_MAP,
  ALLOWED_CURRENCIES,
};
